import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material';
import { BadgeInterface } from './types';

export const Badge: React.FC<BadgeInterface> = ({ children, sx, icon = null }) => {
  return (
    <BadgeContainer sx={sx}>
      <BadgeText>
        {icon && <IconWrapper>{icon}</IconWrapper>}
        {children}
      </BadgeText>
    </BadgeContainer>
  );
};

const BadgeContainer = styled(Box)(() => ({
  border: 'solid 1px #D0D5DD',
  backgroundColor: '#FFFFFF',
  borderRadius: '6px',
  padding: '2px 6px 2px 6px',
}));

const BadgeText = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  fontSize: '12px',
  color: theme.palette.text.secondary,
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
}));

const IconWrapper = styled('span')(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: theme.palette.text.secondary,
  '& svg': {
    fontSize: 'inherit',
    width: '14px',
    height: '14px',
    color: 'inherit',
    fill: 'currentColor',
  },
}));
